module.exports = __webpack_public_path__ + "img/corner-account.cb965ac0.svg";